import React, { useState, useEffect } from "react";
import "../CSS/DashboardTemp.css";
import Header from "./Header";
import Loader from "./Loader";
import Footer from "./footer";
import MySideBar from "./MySideBar";
import "../CSS/myprofile.css";
import { useDispatch, useSelector } from "react-redux";
import NavBar from "./NavBar";
import { login } from "../reducers/loginReducers";

const MyProfile = () => {
    const defaultProfilePhoto = "/webdp.gif";
    const dispatch = useDispatch()

    const [isLoader, setIsLoader] = useState(true);
    const [userData, setUserData] = useState({
        profilePhoto: "",
        username: "",
        email: "",
        id: "",
        profile_pic: defaultProfilePhoto,
        blob_pic: ""
    });

    const [passwordData, setPasswordData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const [isEditMode, setIsEditMode] = useState(false);
    const [isChangePassword, setIsChangePassword] = useState(false);

    const loginInfo = useSelector((state) => state.login);

    useEffect(() => {
        if (window.location.toString().includes("/user/profile") && !isLoader) {
            document.getElementById("my-profile-sidebar-link").classList.add("active");
        }
    }, [isLoader]);

    useEffect(() => {
        setUserData({
            username: loginInfo.username || "",
            email: loginInfo.email || "",
            id: loginInfo.id || "",
            profile_pic: loginInfo.profile_pic || defaultProfilePhoto,
            profilePhoto: ""
        });
        setIsLoader(false);
    }, [loginInfo]);

    const handleUserDataChange = (e) => {
        if (isEditMode) {
            const { name, value } = e.target;
            setUserData({
                ...userData,
                [name]: value,
            });
        }
    };

    const handlePasswordDataChange = (e) => {
        if (isEditMode) {

            const { name, value } = e.target;
            setPasswordData({
                ...passwordData,
                [name]: value,
            });
        }
    };

    const handleEditClick = () => {
        setIsEditMode(true);
    };

    const handleSaveClick = (e) => {
        e.preventDefault();

        const data = {
            ...userData , ...passwordData, confPassword: passwordData.confirmPassword,
             profile_pic: userData.profilePhoto, isChangePassword
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }

        const apiUrl = "http://localhost:8080/api/customer/update";
        fetch(apiUrl, requestOptions).then(
            response => {
                return response.json();
            }
        ).then(data => {
            console.log(data)
            if (data.id) {
                dispatch(login(data));
                localStorage.setItem("infinity_user", JSON.stringify(data))
                setIsEditMode(false);

                // navigate("/")
            }
            else {
                // setError4(data.message)
                console.log(data.message)
            }
        }).catch(error => {
            // setError4(error)
            console.error(error)
        });

        console.log("User data saved:", userData);
    };

    const handleCancelClick = () => {
        setIsEditMode(false);
        // Reset user data to initial or fetched values
        setUserData({
            profile_pic: loginInfo.profile_pic || defaultProfilePhoto,
            username: loginInfo.username || "",
            email: loginInfo.email || "",
            id: loginInfo.id || "",
            profilePhoto: ""
        });
        // Reset password data
        setPasswordData({
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        });
    };

    const handleProfilePhotoChange = (e) => {
        if (isEditMode) {
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.onload = () => {
                setUserData({
                    ...userData,
                    profile_pic: reader.result,
                    profilePhoto: reader.result
                });
            };
             reader.readAsDataURL(file);
        }
    };
    return (
        <div>
            <Header />
            {isLoader ? (
                <Loader />
            ) : (
                <div className="mypro-dashboard dashboard row dark" id="dashboard">
                    <MySideBar />

                    <div id="content" className="mypro-content">
                        <NavBar isPencil={true} isEditMode={isEditMode} handleEditClick={handleEditClick} profilePhoto={userData.profile_pic} />

                        <div className="main-mypro">
                            <form onSubmit={handleSaveClick}>
                                <>
                                    <label key="profile-photo-label" className="label">Profile Photo:</label>
                                    <img
                                        className="DPimage"
                                        src={userData.profile_pic}
                                        alt="Profile"
                                    />
                                    {isEditMode && (
                                        <input
                                            type="file"
                                            name="profilePhoto"
                                            onChange={handleProfilePhotoChange}
                                            className="mypro-input-file"
                                            style={{
                                                border: 'none',
                                                outline: 'none',
                                            }}
                                        />
                                    )}
                                </>

                                <label key="username-label" className="label">Username:</label>
                                {!isEditMode && <span key="username-span" className="span">{userData.username}</span>}
                                {isEditMode && (
                                    <input
                                        type="text"
                                        name="username"
                                        value={userData.username}
                                        onChange={handleUserDataChange}
                                        className="mypro-input-profile"
                                        key="username-input"
                                    />
                                )}

                                <label key="email-label" className="label">Email:</label>
                                {!isEditMode && <span key="email-span" className="span">{userData.email}</span>}
                                {isEditMode && (
                                    <input
                                        type="email"
                                        name="email"
                                        value={userData.email}
                                        onChange={handleUserDataChange}
                                        className="mypro-input-profile"
                                        key="email-input"
                                    />
                                )}
                                <label key="id-label" className="label">User ID:</label>
                                {!isEditMode && <span key="id-span" className="span">{userData.id}</span>}
                                {isEditMode && (
                                    <input
                                        type="text"
                                        name="id"
                                        value={userData.id}
                                        onChange={handleUserDataChange}
                                        className="mypro-input-profile disabled-input"
                                        key="id-input"
                                        disabled
                                    />
                                )}

                                {isEditMode && (
                                    <>
                                        <label key="password-label" className="label">Password:</label>
                                        <span key="password-span" className="span">*****</span>
                                        {isChangePassword ?
                                            <a key="change-password-link" className="change-password-button" onClick={() => setIsChangePassword(false)}> Go Back </a> :
                                            <a key="change-password-link" className="change-password-button" onClick={() => setIsChangePassword(true)}>Change Password</a>
                                        }
                                        {
                                            isChangePassword && (
                                                <>
                                                    <label className="label" htmlFor="oldPassword">Old Password:</label>
                                                    <input
                                                        type="text"
                                                        name="oldPassword"
                                                        value={passwordData.oldPassword}
                                                        onChange={handlePasswordDataChange}
                                                        className="myproPassword"
                                                        key="oldPassword-input"
                                                    />

                                                    <label className="label" htmlFor="newPassword">New Password:</label>
                                                    <input
                                                        type="text"
                                                        name="newPassword"
                                                        value={passwordData.newPassword}
                                                        onChange={handlePasswordDataChange}
                                                        className="myproPassword"
                                                        key="newPassword-input"
                                                    />

                                                    <label className="label" htmlFor="confirmPassword">Confirm Password:</label>
                                                    <input
                                                        type="text"
                                                        name="confirmPassword"
                                                        value={passwordData.confirmPassword}
                                                        onChange={handlePasswordDataChange}
                                                        className="myproPassword"
                                                        key="confirmPassword-input"
                                                    />
                                                </>

                                            )
                                        }

                                    </>
                                )}

                                {isEditMode && (
                                    <div className="mypro-button-container" key="button-container">
                                        <button className="mypro-button_s" type="submit">Submit</button>
                                        <button className="mypro-button_s" type="button" onClick={handleCancelClick}>
                                            Cancel
                                        </button>
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
};

export default MyProfile;
